module.exports = __webpack_public_path__ + "08_mustache_brown.aad90220.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/08_mustache_brown.png
// module id = SYGH
// module chunks = 0